import { createJsonNormalizer, createShapeNormalizer } from '@change/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_MEMBERSHIP_AWARENESS_PLACEMENT_AB_EXPERIMENT = createFcmConfig(
	'membership_awareness_placement_ab_experiment',
	{
		normalizer: createJsonNormalizer(
			createShapeNormalizer({
				type: 'object',
				shape: {
					experiment_name: { type: 'string' },
				},
			}),
		),
		defaultValue: undefined,
	},
);
